import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/JigsawPuzzleGame/scenes/GameIntro';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(PhaserDemo)'
interface PhaserJigsawPuzzleGameProps {
    onComplete: () => void;

}

interface PhaserJigsawPuzzleGameState {
}

const templateConfig: GameConfig = {
    title: "Jigsaw Puzzle Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 600 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserJigsawPuzzleGame extends React.Component<PhaserJigsawPuzzleGameProps, PhaserJigsawPuzzleGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserJigsawPuzzleGameProps) {
        super(props);
        bindAllOfThis(this, PhaserJigsawPuzzleGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={templateConfig}  onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserJigsawPuzzleGame;



// WEBPACK FOOTER //
// ./src/games/JigsawPuzzleGame/Main.tsx